<article class="card activity-card" [attr.aria-label]="card.label">
  @if (card.context) {
    <p class="activity-card__context">
      <span class="material-icons" aria-hidden="true">{{ card.context.icon }}</span>
      @for (part of card.context.parts; track $index) {
        @if (part.state) {
          <a [uiSref]="part.state" [uiParams]="part.params" [innerHTML]="part.text | emojiHtml"></a>
        } @else {
          <span [innerHTML]="part.text | emojiHtml"></span>
        }
      }
      @if (card.contextDate) {
        <span>{{ card.contextDate | relativeDate }}</span>
      }
    </p>
  }
  <header class="activity-card__header">
    @if (card.author.slug) {
      <a class="activity-card__author" uiSref="profile.about" [uiParams]="{ profileId: card.author.slug }">
        <ng-container *ngTemplateOutlet="author"></ng-container>
      </a>
    } @else {
      <span class="activity-card__author">
        <ng-container *ngTemplateOutlet="author"></ng-container>
      </span>
    }
    <ng-template #author>
      <ut-avatar-badges [user]="card.author" aria-hidden="true"></ut-avatar-badges>
      <span class="activity-card__author-text">
        <span class="activity-card__name">
          {{ card.author.name }}
          @if (card.isYou) {
            <span class="activity-card__you">You</span>
          }
        </span>
        <span class="activity-card__meta">{{ card.type }} <span aria-hidden="true">&middot;</span> {{ card.datePrefix }}{{ card.date | relativeDate }}</span>
      </span>
    </ng-template>
  </header>

  <div class="activity-card__body">
    @if (card.category) {
      <ut-category-link class="activity-card__category" [category]="card.category" />
    }
    @if (card.title) {
      @if (card.route) {
        <a class="activity-card__title" [uiSref]="card.route.state" [uiParams]="card.route.params" [innerHTML]="card.title | emojiHtml"></a>
      } @else {
        <span class="activity-card__title" [innerHTML]="card.title | emojiHtml"></span>
      }
    }
    @if (card.text) {
      <p #content tabindex="-1" class="activity-card__content" [class.activity-card__content--status]="card.isStatus" [class.activity-card__content--expanded]="expanded()" [innerHTML]="card.text"></p>
      @if (isClamped() && !expanded()) {
        @if (card.isStatus) {
          <button type="button" class="activity-card__see-more" (click)="expand()">See more</button>
        } @else if (card.route) {
          <a class="activity-card__see-more" [uiSref]="card.route.state" [uiParams]="card.route.params">See more</a>
        }
      }
    }
  </div>

  @if (card.route) {
    <footer class="activity-card__footer">
      @if (card.likeable) {
        <ut-community-like-action [likeable]="card.likeable"></ut-community-like-action>
      }
      <a class="activity-card__action" [uiSref]="card.route.state" [uiParams]="card.route.params">
        <span class="material-icons" aria-hidden="true">arrow_forward</span>
        {{ card.viewLabel }}
      </a>
      @if ((card.likeable && likeCount) || card.stat) {
        <div class="activity-card__counts">
          @if (card.likeable && likeCount) {
            <button type="button" class="activity-card__count" aria-haspopup="dialog" (click)="showLikes()">{{ likeCount | utNumToK }} {{ likeCount === 1 ? 'like' : 'likes' }}</button>
          }
          @if (card.stat) {
            <span class="activity-card__stat">{{ card.stat }}</span>
          }
        </div>
      }
    </footer>
  }
</article>
